import { render, staticRenderFns } from "./orderView.vue?vue&type=template&id=7ca55037&scoped=true&"
import script from "./orderView.vue?vue&type=script&lang=js&"
export * from "./orderView.vue?vue&type=script&lang=js&"
import style0 from "./orderView.vue?vue&type=style&index=0&id=7ca55037&scoped=true&lang=css&"
import style1 from "./orderView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca55037",
  null
  
)

export default component.exports